import { Button, Chip, IconButton, styled, Tooltip } from '@mui/material'
import Grid from '@mui/material/Grid2'
import { isEmpty, map } from 'lodash'
import { FC, useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { Notistack } from '../../../../components/Notistack'
import { useRequestsStore } from '../../../../store/storeRequests'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { ReplyContentTextDTO } from '../../../../swagger/dto'
import { SidebarType } from '../../../../types/sidebars'
import CopyIcon from './../../../../assets/icons/Copy.svg?react'

const StyledButton = styled(Button, {
    shouldForwardProp: (propName: string) => propName !== 'isActive',
})<{ isActive: boolean }>(({ theme, isActive }) => ({
    borderColor: isActive ? theme.palette.primary.main : theme.palette.action.selected,
    padding: '8px 12px',
}))

interface Props {
    citations: ReplyContentTextDTO['citations']
}

const CitationsButton: FC<Props> = ({ citations }) => {
    const { openSidebarType, setOpenSidebarType } = useWrapperStore((state) => state)

    const showCitationSidebar = openSidebarType === SidebarType.CITATIONS

    const { setMessageCitations } = useRequestsStore((state) => state)
    const [openSnackbar, setOpenSnackbar] = useState(false)

    const citationList = map(citations, 'link').join(', ')

    const handleCloseSnackbar = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return
        }

        setOpenSnackbar(false)
    }

    const handleClick = () => {
        setMessageCitations(citations)
        setOpenSidebarType(showCitationSidebar ? null : SidebarType.CITATIONS)
    }

    if (isEmpty(citations)) {
        return null
    }

    return (
        <>
            <Grid
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '8px',
                }}>
                <Tooltip title="Показать или скрыть все источники">
                    <StyledButton
                        onTouchStart={handleClick}
                        isActive={showCitationSidebar}
                        variant="outlined"
                        onClick={handleClick}
                        endIcon={
                            <CopyToClipboard
                                onCopy={() => setOpenSnackbar(true)}
                                text={citationList}>
                                <IconButton
                                    size="small"
                                    onClick={(evt) => evt.stopPropagation()}
                                    onTouchEnd={(evt) => evt.stopPropagation()}
                                    onTouchStart={(evt) => evt.stopPropagation()}
                                    sx={{
                                        backgroundColor: (theme) => theme.palette.primary.main,
                                        padding: '4px',
                                    }}
                                    edge="end">
                                    <CopyIcon />
                                </IconButton>
                            </CopyToClipboard>
                        }>
                        <Chip
                            size="small"
                            sx={{
                                '& .MuiChip-label': {
                                    marginRight: '0',
                                },
                            }}
                            label={citations?.length}
                        />
                        Источники
                    </StyledButton>
                </Tooltip>

                <Notistack
                    open={openSnackbar}
                    isError={false}
                    message="Источники скопированы"
                    onClose={handleCloseSnackbar}
                />
            </Grid>
        </>
    )
}

export default CitationsButton
